export function getVisitorContactsForTenant({ tenant, schema, isConnect = false, user }) {
  const contacts = [];

  tenant.location.multiTenancyVisitorContacts.models.forEach(({ id, fullName, email, phoneNumber, avatar }) => {
    if (user && user.id !== id) return;

    contacts.push(
      schema[isConnect ? 'connectVisitorContacts' : 'visitorContacts'].create({
        tenant,
        id,
        name: fullName,
        email,
        phoneNumber,
        avatar,
      })
    );
  });

  return contacts;
}
